import React from 'react';
import { Phone, Mail, MapPin, MessageCircle, Instagram } from 'lucide-react';
import { contactInfo, apartmentInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-xl font-bold mb-4">
              {apartmentInfo.name}
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              {apartmentInfo.tagline}
            </p>
            {/* Social Links */}
            <a
              href={contactInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-sage-600 hover:bg-sage-500 text-white px-4 py-2 rounded-full text-sm transition-colors duration-300"
            >
              <Instagram size={18} />
              Pratite nas
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">Brzi linkovi</h4>
            <ul className="space-y-2">
              {[
                { href: '#galerija', label: 'Galerija' },
                { href: '#o-apartmanu', label: 'O apartmanu' },
                { href: '#lokacija', label: 'Lokacija' },
                { href: '#atrakcije', label: 'Atrakcije' },
                { href: '#rezervacija', label: 'Rezervacija' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-sage-400 transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4">Kontakt</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <MapPin size={16} className="text-sage-400 flex-shrink-0" />
                {contactInfo.address}
              </li>
              <li>
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-sage-400 transition-colors text-sm"
                >
                  <Phone size={16} className="text-sage-400 flex-shrink-0" />
                  {contactInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-sage-400 transition-colors text-sm"
                >
                  <Mail size={16} className="text-sage-400 flex-shrink-0" />
                  {contactInfo.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${contactInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-sage-400 transition-colors text-sm"
                >
                  <MessageCircle size={16} className="text-sage-400 flex-shrink-0" />
                  WhatsApp / Viber
                </a>
              </li>
              <li>
                <a
                  href={contactInfo.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-gray-400 hover:text-sage-400 transition-colors text-sm"
                >
                  <Instagram size={16} className="text-sage-400 flex-shrink-0" />
                  @peakview508_apartman
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} {apartmentInfo.name}. Sva prava zadržana.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;